import StructureIdList from "../../js/struct/StructureIdList.js";

export default class StructureIdSearchList {
    /** @type {Map<string, number>} */
    #idToIdx = new Map();
    /** @type {StructureIdList} */
    #structureIds = new StructureIdList([]);
    /** @type {StructureForms[]} */
    #forms = [];

    /**
     * @param {StructureId} structureIds
     * @param {StructureForms} forms
     */
    add(structureIds, forms) {
        this.#structureIds = this.#structureIds.with([structureIds]);
        this.#forms.push(forms);
    }
    get uidsToSearchFor() {
        const result = [];
        for (let form of this.#forms)
            result.push(...form.selectedUidsDependsOnOptions);
        return result;
    }

    /**
     *
     * @param {StructureId} id
     * @returns {StructureForms}
     */
    getForms(id) {
        const i = this.#structureIds.indexOf(id);
        return this.#forms[i];
    }
    /**
     *
     * @param {StructureId} id
     * @param {StructureForms} forms
     */
    setForms(id, forms) {
        const i = this.#structureIds.indexOf(id);
        this.#forms[i] = forms;
    }

    /** @param {StructureId} id */
    deleteForm(id){
        const form = this.#forms.find(f => f.parent === id.parent);
        const i = this.#forms.indexOf(form);
        this.#forms.splice(i, 1);
        this.#structureIds.deleteForm(id);
    }
}